export default {
  "grapesjs-signature-pad": {
    name: "Signature Pad",
    "call-to-action": "Please sign here",
  },
};
